import { Flex, Space } from '@billy/design-system'
import { ReactElement } from 'react'

import { InvoicePaymentTermAndDueDate } from './elements/InvoicePaymentTermAndDueDate'
import { PaymentMethods } from './elements/PaymentMethods'
import * as Styled from './styles'

export const Payments = (): ReactElement => {
  return (
    <Styled.PaymentsWrapper>
      <Flex flexDirection="column">
        <InvoicePaymentTermAndDueDate />
        <Space size="s24" />
        <PaymentMethods />
      </Flex>
    </Styled.PaymentsWrapper>
  )
}
